import { render, staticRenderFns } from "./ExploreGigwi.vue?vue&type=template&id=ddebde9a&scoped=true"
import script from "./ExploreGigwi.vue?vue&type=script&lang=js"
export * from "./ExploreGigwi.vue?vue&type=script&lang=js"
import style0 from "./ExploreGigwi.vue?vue&type=style&index=0&id=ddebde9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddebde9a",
  null
  
)

export default component.exports